import type { Finding } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapSingle } from '../normalize'

export const resolveFinding = async ({
  userRole,
  dataCollectionStatementId,
  findingId,
}: {
  userRole: string
  dataCollectionStatementId: string
  findingId: string
}): Promise<Finding> => {
  const response = await apiClient.put(`${endpoints.findings}/${findingId}`, {
    data: { resolved: true, dataCollectionStatementId, userRole },
  })
  return unwrapSingle<Finding>(response)
}

export default resolveFinding
